/**
 * Agent service: Summarizer
 * Creates clinical summaries from conversation insights
 */

import { callGroq } from "./decomposer";
import { API_CONFIG } from "../config/constants";

/**
 * Create a clinical summary from conversation goals and insights
 * @param {string} questionText - Original doctor question
 * @param {Array} goalsWithInsights - Goals with captured insights
 * @param {string} patientName - Patient's name
 * @param {Array} memoryChunks - Historical context
 * @returns {Promise<string>} - Clinical summary
 */
export const summarizerAgent = async (questionText, goalsWithInsights, patientName, memoryChunks) => {
  const memory = memoryChunks.length ? `\n\nHistorical context:\n${memoryChunks.slice(0, 5).join("\n")}` : "";

  const system = `You are a clinical summarizer. Create a concise but insightful summary for a doctor. Format it clearly with sections: Key Findings, Patterns & Trends, Concerns, Recommendations. Use professional but readable language. 2-3 sentences per section.`;

  const prompt = `Doctor's question: "${questionText}"
Patient: ${patientName}

Goals and findings:
${goalsWithInsights
  .map((g, i) => `${i + 1}. ${g.goal}\n   Insights: ${g.insights || "No specific insights captured."}`)
  .join("\n\n")}${memory}`;

  try {
    const summary = await callGroq(
      system,
      prompt,
      API_CONFIG.groq.summaryMaxTokens
    );
    return summary;
  } catch (error) {
    return "Summary could not be generated. Please review the conversation directly.";
  }
};
